"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const button_module_scss_1 = __importDefault(require("./button.module.scss"));
const cgui_core_atoms_icon_1 = require("@campgladiator/cgui-core.atoms.icon");
const cgui_core_atoms_typography_1 = require("@campgladiator/cgui-core.atoms.typography");
const ButtonContent = ({ icon, size, styles, children }) => (react_1.default.createElement(react_1.default.Fragment, null,
    (icon === null || icon === void 0 ? void 0 : icon.type) === "solid" && (react_1.default.createElement(cgui_core_atoms_icon_1.Icon.Solid, { className: styles.icon, name: icon.name, "data-size": size })),
    (icon === null || icon === void 0 ? void 0 : icon.type) === "line" && (react_1.default.createElement(cgui_core_atoms_icon_1.Icon.Line, { className: styles.icon, name: icon.name, "data-size": size })),
    children && (react_1.default.createElement(cgui_core_atoms_typography_1.Label, { className: styles.content, size: size }, children))));
const Button = react_1.default.forwardRef((_a, ref) => {
    var { buttonType = "button", emphasis = "primary", variation = "solid", size = "default", floating = false, disabled = false, icon, theme = "core" } = _a, props = __rest(_a, ["buttonType", "emphasis", "variation", "size", "floating", "disabled", "icon", "theme"]);
    return buttonType === "link" ? (react_1.default.createElement(LinkButton, Object.assign({ emphasis: emphasis, variation: variation, size: size, floating: floating, disabled: disabled, icon: icon, theme: theme }, props), props.children)) : (react_1.default.createElement(ActionButton, Object.assign({ emphasis: emphasis, variation: variation, size: size, floating: floating, disabled: disabled, icon: icon, theme: theme, ref: ref }, props), props.children));
});
const ActionButton = react_1.default.forwardRef((_a, ref) => {
    var { className, floating } = _a, props = __rest(_a, ["className", "floating"]);
    return (react_1.default.createElement("button", Object.assign({ className: (0, classnames_1.default)(button_module_scss_1.default.button, className), "data-size": props.size, "data-variation": props.variation, "data-emphasis": props.emphasis, "data-disabled": props.disabled, disabled: props.disabled, "data-floating": floating, "data-icon": !!props.icon, "data-children": !!props.children, "data-theme": props.theme, style: button_module_scss_1.default, ref: ref }, props),
        react_1.default.createElement(ButtonContent, { icon: props.icon, size: props.size, styles: button_module_scss_1.default }, props.children)));
});
const LinkButton = (_a) => {
    var { className, floating } = _a, props = __rest(_a, ["className", "floating"]);
    const buttonStyle = !props.disabled
        ? {}
        : { pointerEvents: "none" };
    return (react_1.default.createElement("a", Object.assign({ className: (0, classnames_1.default)(button_module_scss_1.default.button, className), "data-size": props.size, href: props.href, "data-disabled": props.disabled, "data-variation": props.variation, "data-emphasis": props.emphasis, "data-floating": floating, "data-icon": !!props.icon, "data-children": !!props.children, "data-theme": props.theme, style: Object.assign(Object.assign({}, props.style), buttonStyle) }, props),
        react_1.default.createElement(ButtonContent, { icon: props.icon, size: props.size, styles: button_module_scss_1.default }, props.children)));
};
exports.default = (0, react_1.memo)(Button);
//# sourceMappingURL=button.js.map